import { render } from "./stock_levels.vue?vue&type=template&id=2d3f7fcc&scoped=true"
import script from "./stock_levels.vue?vue&type=script&lang=js"
export * from "./stock_levels.vue?vue&type=script&lang=js"

import "./stock_levels.vue?vue&type=style&index=0&id=2d3f7fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3f7fcc"]])

export default __exports__